<template>
  <div>
    <!-- begin login-cover -->
    <div class="login-cover">
      <div
        class="login-cover-image"
        v-bind:style="{
          backgroundImage:
            'url(' + require('@/assets/images/login-bg.png') + ')'
        }"
      ></div>
      <div class="login-cover-bg"></div>
    </div>
    <!-- end login-cover -->

    <!-- begin login -->
    <div class="login login-v2" data-pageload-addclass="animated fadeIn">
      <!-- begin brand -->
      <div class="login-header">
        <div class="brand">
          <span
            ><img
              src="@/assets/images/bonacube-logo-white.png"
              style="max-width: 300px"
          /></span>
        </div>
      </div>
      <!-- end brand -->
      <!-- begin login-content -->
      <div class="login-content">
        <form @submit.prevent="handleLogin" class="margin-bottom-0">
          <div class="form-group m-b-20">
            <input
              v-model="username"
              type="text"
              class="form-control form-control-lg"
              placeholder="Email Address"
              required
            />
          </div>
          <div class="form-group m-b-20">
            <input
              v-model="password"
              type="password"
              class="form-control form-control-lg"
              placeholder="Password"
              required
            />
          </div>
          <div class="checkbox checkbox-css m-b-20">
            <input type="checkbox" id="remember_checkbox" />
            <label for="remember_checkbox"> Remember Me </label>
          </div>
          <div class="login-buttons">
            <button type="submit" class="btn btn-success btn-block btn-lg">
              Sign me in
            </button>
          </div>
          <div class="m-t-20">
            Not a member yet? Click <a href="javascript:;">here</a> to register.
          </div>
          <div class="m-t-20">
            Forgot your password? Click
            <router-link to="/forgot">here</router-link> to reset your password.
          </div>
        </form>
      </div>
      <!-- end login-content -->
    </div>
    <!-- end login -->
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import PageOptions from '../config/PageOptions.vue'

export default {
  created() {
    PageOptions.pageEmpty = true
  },
  beforeRouteLeave(to, from, next) {
    PageOptions.pageEmpty = false
    next()
  },
  data: () => ({
    username: '',
    password: ''
  }),
  computed: {
    ...mapState('auth', ['status'])
  },
  methods: {
    ...mapActions('auth', ['login']),
    handleLogin() {
      const { username, password } = this
      if (username && password) {
        this.login({ username, password })
      }
    }
  }
}
</script>
